import type { PoisonQueueMessage } from '@urbanx/agx.support.client';

export const messageFilterLabels = {
  campaignId: 'Campaign ID',
  contractId: 'Contract ID',
  eventType: 'Event type',
  userId: 'User ID',
};

export type MessageFilters = Record<keyof typeof messageFilterLabels, string>;

function property(value: unknown, name: string): unknown {
  if (!value || typeof value !== 'object') return undefined;
  return Object.entries(value).find(([key]) => key.toLowerCase() === name.toLowerCase())?.[1];
}

export function filterMessages(messages: PoisonQueueMessage[], filters: MessageFilters) {
  const activeFilters = Object.entries(filters)
    .map(([key, value]) => [key, value.trim().toLowerCase()])
    .filter(([, value]) => value);
  if (!activeFilters.length) return messages;

  return messages.filter((message) => {
    let body: unknown;
    try {
      body = JSON.parse(message.messageBodyJson ?? '');
    } catch {
      // Malformed messages remain available when filters are cleared.
      return false;
    }
    const data = property(body, 'data');
    return activeFilters.every(([key, search]) => {
      const value =
        key === 'eventType' ? (property(body, key) ?? property(data, key)) : property(data, key);
      return typeof value === 'string' && value.toLowerCase().includes(search);
    });
  });
}

export function formatMessageBody(body?: string) {
  if (!body) return '-';
  try {
    return JSON.stringify(JSON.parse(body), null, 2);
  } catch {
    return body;
  }
}
